import {reactive, readonly} from 'vue'

const state = reactive({
  failed: false,
  pending: 0,
  visible: false,
})

let hideTimer = null

function clearHideTimer() {
  if (hideTimer !== null) {
    window.clearTimeout(hideTimer)
    hideTimer = null
  }
}

function settle(failed) {
  state.pending = Math.max(0, state.pending - 1)
  state.failed = state.failed || failed

  if (state.pending === 0) {
    clearHideTimer()
    hideTimer = window.setTimeout(() => {
      state.visible = false
      state.failed = false
      hideTimer = null
    }, 300)
  }
}

export const progress = {
  start() {
    clearHideTimer()
    if (state.pending === 0) state.failed = false
    state.pending += 1
    state.visible = true
  },
  finish() {
    settle(false)
  },
  fail() {
    settle(true)
  },
  reset() {
    clearHideTimer()
    state.failed = false
    state.pending = 0
    state.visible = false
  },
}

export const progressState = readonly(state)
